import { jsx as p, Fragment as D, jsxs as U } from "@emotion/react/jsx-runtime";
import { useRef as u, useState as O, useId as j, useCallback as d, useEffect as _, isValidElement as H, cloneElement as M } from "react";
import { createPortal as V } from "react-dom";
import { DEFAULT_POSITIONS as k, computePositions as q } from "./helpers.js";
import { StyledSpan as B, StyledTooltip as X } from "./Tooltip.styled.js";
import { DEFAULT_TOOLTIP_COMPONENT_Z_INDEX as Y } from "../../constants/zIndex.js";
const Z = "TooltipChildrenContainerSelector", $ = 500;
function m() {
}
const ee = ({
  children: i,
  className: w,
  visible: f,
  id: g,
  variant: F = "theme",
  maxWidth: R = 232,
  text: E = "",
  placement: T = "auto",
  caret: b = !0,
  zIndex: y = Y,
  hoverDelay: v = $
}) => {
  const e = u(null), s = u(null), c = u(void 0), n = u(void 0), [a, I] = O(!1), [A, N] = O({
    ...k
  }), h = j(), P = g ?? `tooltip-${h}`, t = f !== void 0, l = d(() => {
    s.current instanceof HTMLElement && e.current && N(q({
      childrenRef: s,
      placement: T,
      tooltipRef: e
    }));
  }, [T, s, e]), r = d(() => {
    e.current && (e.current.style.animation = "none"), l();
  }, [l]), L = d(() => {
    I(!1), c.current = void 0, window.removeEventListener("scroll", r, !0);
  }, [r]), o = d((C) => () => {
    n.current && (clearTimeout(n.current), n.current = void 0), !C && e.current ? L() : n.current = setTimeout(() => {
      I(C), n.current = void 0;
    }, v);
  }, [L, v]);
  if (_(() => (a && (l(), window.addEventListener("scroll", r, !0)), () => {
    window.removeEventListener("scroll", r, !0), c.current && (clearTimeout(c.current), c.current = void 0);
  }), [l, r, a]), _(() => {
    t && o(f)();
  }, [t, o, f]), !E) return /* @__PURE__ */ p(D, { children: i });
  const S = {
    ref: s,
    // Pass the triggerRef to the children element
    "aria-describedby": P,
    "data-css-selector": Z,
    onPointerEnter: t ? m : o(!0),
    onPointerLeave: t ? m : o(!1),
    onFocus: t ? m : o(!0),
    onBlur: t ? m : o(!1)
  }, x = H(i) ? M(i, {
    ...S
  }) : /* @__PURE__ */ p(B, { ...S, className: w, tabIndex: 0, children: i });
  return /* @__PURE__ */ U(D, { children: [
    x,
    a && V(/* @__PURE__ */ p(X, { ref: e, positions: A, caret: b, maxWidth: R, role: "tooltip", id: P, variant: F, zIndex: y, children: E }), document.body)
  ] });
};
export {
  ee as Tooltip,
  Z as TooltipChildrenContainerSelector
};
